import * as React from 'react';
import { getEventBusIfDefined } from '@cian/event-bus';
import { mergeStyles } from '@cian/utils/lib/shared/style';

import { createSpecialPromoLink, IPromoLink, PIK_KEY } from '../../app/models/promo';
import { ISpecialPromoThumbSchema } from '../repositories/special-promos/entities/schemas/SpecialPromoThumbSchema';

interface ISpecialPromoLinkProps {
  specialPromos: ISpecialPromoThumbSchema[];
  canPreviewSpecialPromos: boolean;
  regionId: number;
  mobileBaseUrl: string;
  isMobile?: boolean;
  pikRegions: number[];
}

export interface ISpecialPromoLinkState {
  link?: IPromoLink;
}

const LinkImage = ({ link, isMobile }: { link: IPromoLink; isMobile?: boolean }) => {
  return link.isLegacy ? (
    <span className={isMobile ? `c-header__bottom-link-${link.key}-icon` : `c-header-bottom-menu-${link.key}-icon`} />
  ) : (
    <span
      className={isMobile ? 'c-header__bottom-link-special-promo-icon' : 'c-header-bottom-menu-special-promo-icon'}
      style={{
        backgroundImage: `url(${isMobile && link.logoMobileUrl ? link.logoMobileUrl : link.logoUrl})`,
      }}
    />
  );
};

const getMobileLinkContent = (link: IPromoLink) => {
  const image = <LinkImage link={link} isMobile />;

  switch (link.key) {
    case PIK_KEY:
      return (
        <span>
          Новостройки <span className="c-header__bottom-link__text">от ПИК {image}</span>
        </span>
      );
    default:
      return (
        <span>
          Новостройки от&nbsp;
          <span className="c-header__bottom-link-special-promo-name">
            {link.mobileName}
            {image}
          </span>
        </span>
      );
  }
};

export class SpecialPromoLink extends React.Component<ISpecialPromoLinkProps, ISpecialPromoLinkState> {
  public constructor(props: ISpecialPromoLinkProps) {
    super(props);

    const { specialPromos, canPreviewSpecialPromos, regionId, pikRegions } = props;

    this.state = {
      link: createSpecialPromoLink(specialPromos, canPreviewSpecialPromos, regionId, pikRegions),
    };
  }

  public componentDidMount() {
    const eventBus = getEventBusIfDefined();

    if (eventBus) {
      eventBus.subscribe('header:region_changed', this.changeRegionHandler);
    }
  }

  public render() {
    const { link } = this.state;
    const { mobileBaseUrl, isMobile } = this.props;

    if (!link) {
      return null;
    }

    return (
      <a
        {...mergeStyles(
          isMobile ? 'c-header__bottom-link' : 'c-header-link',
          link.desktopName.length > 3 ? 'c-header-link_no-tablet-promo' : undefined,
        )}
        href={isMobile ? `//${mobileBaseUrl}${link.mobileUrl}` : link.desktopUrl}
        onClick={this.trackingEvent}
      >
        {isMobile ? (
          getMobileLinkContent(link)
        ) : (
          <span>
            <LinkImage link={link} />
            {link.desktopName && <span className="c-header__bottom-link-special-promo-text">{link.desktopName}</span>}
          </span>
        )}
      </a>
    );
  }

  private trackingEvent = () => {
    const { link } = this.state;

    if (link && window._headerTrackingEvent) {
      window._headerTrackingEvent(link.key);
    }
  };

  private changeRegionHandler = (event: CianEventBus.IEvent) => {
    const { specialPromos, canPreviewSpecialPromos, pikRegions } = this.props;
    const regionId = Number(event.type);

    if (!regionId) {
      return;
    }

    this.setState({
      link: createSpecialPromoLink(specialPromos, canPreviewSpecialPromos, regionId, pikRegions),
    });
  };
}
